// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    GetUnfilteredProducts,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";

export const XngPopulateApiParameter: any = (props: any) => {
    props.apiParameter = {
        ...props.apiParameter,
        ...(props.parameter.additionalProps ?? {}),
    };

    // To show all products in Sub Categories
    const includeProductsInSubCategories = props.parameter?.["includeProductsInSubCategories"];
    // TOR-611: To get all attributes from Sub Categories
    const restrictAttributesToCategory = props.parameter?.["restrictAttributesToCategory"];

    if (props.apiParameter.categoryId) {
        props.apiParameter = {
            ...props.apiParameter,
            includeProductsInSubCategories,
            includeAttributes: [
                ...props.apiParameter.includeAttributes,
                ...(includeProductsInSubCategories ? ["notFromCategory"] : []),
            ],
            restrictAttributesToCategory,
        };
    }
};

/** We should remove includeProductsInSubCategories from ApiParameter because this option need CategoryId
 * and GetUnfilteredProducts remove CategoryId from ApiParameter
 */

export const XngGetUnfilteredProducts: any = (props: any) => {
    if (!props.result.productFilters.pageCategoryId) {
        const apiParameter = { ...props.apiParameter };
        if (props.apiParameter.includeProductsInSubCategories) {
            delete apiParameter.includeProductsInSubCategories;
        }
        if (props.apiParameter.restrictAttributesToCategory) {
            delete apiParameter.restrictAttributesToCategory;
        }
        props.apiParameter = { ...apiParameter };
    }

    const isStockedOnly = props.result?.productFilters?.stockedItemsOnly === true;

    if (isStockedOnly) {
        return;
    }
    GetUnfilteredProducts(props);
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, GetUnfilteredProducts, XngGetUnfilteredProducts);
